export const formatCurrency = (value) =>
  new Intl.NumberFormat("es-CO", {
    style: "currency",
    currency: "COP",
    minimumFractionDigits: 0,
  }).format(value || 0);

export const formatDate = (date) => {
  if (!date) return "";

  return new Date(date).toLocaleDateString("es-CO", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
};

export const findModuloValue = (modulos, keywords = []) => {
  const list = Array.isArray(modulos) ? modulos : [];
  const keys = keywords.map((k) => String(k).toLowerCase());

  const parseAmount = (raw) => {
    const n = Number(raw);
    return Number.isFinite(n) ? n : 0;
  };

  // 1) Prioridad: contratos_servicios (valores por módulo real)
  const servicios = list.flatMap((m) => (Array.isArray(m?.contratos_servicios) ? m.contratos_servicios : []));
  const servicio = servicios.find((s) => {
    const name = String(s?.nombre || "").toLowerCase();
    return keys.some((k) => name.includes(k));
  });

  if (servicio) {
    return parseAmount(servicio?.valor ?? servicio?.valor_total ?? servicio?.valor_inicial);
  }

  // 2) Fallback: contratos_modulos
  const modulo = list.find((m) => {
    const name = String(m?.nombre || "").toLowerCase();
    return keys.some((k) => name.includes(k));
  });

  return parseAmount(modulo?.valor_total ?? modulo?.valor ?? modulo?.valor_inicial);
};

export const capitalizeWords = (texto) => {
  return texto
    .split(" ")
    .map((palabra) =>
      palabra.charAt(0).toUpperCase() + palabra.slice(1).toLowerCase()
    )
    .join(" ");
};